import React, { useEffect } from 'react';
import MainRoutes from './mainRoutes';
import { MenuBar } from './components/MenuBar';
import { useSelector, useDispatch } from 'react-redux';
import { mainStateSelector, MAIN_STATE_KEY } from '../main-reducer';
import { mainCreators } from '../main-action';
import { RBHError } from '../../shared/components';
import { useLoadingSelector } from 'rbh-merchant-core';
import { MAIN_REQUEST_ID_LIST, MASTER_DATA_TYPE } from '../main-constant';

export const Main: React.FC<Props> = () => {
  const dispatch = useDispatch();
  const masterdataStatus = useSelector(mainStateSelector(MAIN_STATE_KEY.MASTER_DATA_STATUS)) as MASTER_DATA_TYPE;
  const loading = useLoadingSelector(MAIN_REQUEST_ID_LIST.GET_MASTER_DATA);

  useEffect(() => {
  }, []);

  const reload = () => {
    dispatch(mainCreators.callMasterDataAndLandingStatus());
  };

  return (
    <div>
      <MenuBar>
        {loading ? null :
          masterdataStatus === MASTER_DATA_TYPE.BLANK ? null
            : masterdataStatus === MASTER_DATA_TYPE.SUCCESS ? <MainRoutes /> : <RBHError onOk={() => reload()} />}
      </MenuBar>
    </div>
  );
};

type Props = {};
